var pt_br = {
    values: {
        'Trips': 'Viagens',
        'No trips found': 'Nenhuma viagem encontrada',
        'for the selected timespan': 'no timespan selecionado',
        'Select a new timespan or apply new filters': 'Selecione um novo timespan ou aplique novos filtros'
    }
}

module.exports = pt_br
